import { NgModule } from '@angular/core';
import { AmdMediaQueryModule } from '../utilities/media-query/media-query.module';
import { AmdScrollModule } from '../utilities/scroll/scroll.module';
import { AmdParallaxDirective } from './parallax.directive';
export class AmdParallaxModule {
}
AmdParallaxModule.decorators = [
    { type: NgModule, args: [{
                imports: [AmdMediaQueryModule, AmdScrollModule],
                declarations: [AmdParallaxDirective],
                exports: [AmdParallaxDirective]
            },] },
];
/**
 * @nocollapse
 */
AmdParallaxModule.ctorParameters = () => [];
function AmdParallaxModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdParallaxModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdParallaxModule.ctorParameters;
}
//# sourceMappingURL=parallax.module.js.map
//# sourceMappingURL=parallax.module.js.map
